var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 332.59,
    height: 263.504,
    viewBox: "0 0 332.59 263.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M0-231.028H332.59v-263.5H0Z",
    transform: "translate(0 494.532)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(0 37.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M-56.651-42.144l3.078-12.387-7.783-1.934a26.366,26.366,0,0,0-1.291-7.363l7.04-4.237L-62.189-79l-7.2,4.336a26.338,26.338,0,0,0-5.838-4.287l2.033-8.181-12.387-3.078-2,8.046a26.374,26.374,0,0,0-7.348.943l-4.186-6.955L-110.054-81.6l3.992,6.632a26.4,26.4,0,0,0-4.865,6.179l-7.259-1.8L-121.265-58.2l6.849,1.7a26.319,26.319,0,0,0,1.065,8.293l-5.881,3.539,6.583,10.937,5.717-3.441a26.407,26.407,0,0,0,6.894,5.123l-1.6,6.45,12.387,3.079,1.636-6.586a26.356,26.356,0,0,0,8.308-1.412l3.59,5.965,10.936-6.583-3.785-6.286a26.367,26.367,0,0,0,4.544-6.553Zm-19.338-7.609a13.052,13.052,0,0,1-1.564,2.414,13.258,13.258,0,0,1-6.626,4.4,13.069,13.069,0,0,1-2.327.464,13.148,13.148,0,0,1-4.574-.273,13.134,13.134,0,0,1-3.8-1.676,13.085,13.085,0,0,1-1.754-1.308,13.261,13.261,0,0,1-4.249-7.4,13.112,13.112,0,0,1-.227-2.436,13.193,13.193,0,0,1,.349-3.264,13.184,13.184,0,0,1,1.9-4.171,13.213,13.213,0,0,1,1.923-2.3,13.269,13.269,0,0,1,5.959-3.175,13.064,13.064,0,0,1,3.474-.41,13.2,13.2,0,0,1,2.833.374A13.166,13.166,0,0,1-81.628-67.3a13.124,13.124,0,0,1,2.962,2.179,13.279,13.279,0,0,1,3.327,5.181,13.206,13.206,0,0,1,.645,3.365,13.1,13.1,0,0,1-.3,4.144,13.212,13.212,0,0,1-1,2.678",
    transform: "translate(121.265 90.213)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(262.249 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M-37.2-31.1l3.28-8.133-5.11-2.061a18.1,18.1,0,0,0-.173-5.133l5.2-2.209-3.433-8.071-5.315,2.261a18.138,18.138,0,0,0-3.562-3.476l2.166-5.371-8.134-3.28-2.13,5.283a18.117,18.117,0,0,0-5.09-.061l-2.183-5.133-8.07,3.432,2.081,4.895a18.131,18.131,0,0,0-3.9,3.739l-4.766-1.922-3.28,8.133,4.5,1.814a18.111,18.111,0,0,0-.069,5.743l-4.339,1.846,3.431,8.07,4.219-1.794a18.094,18.094,0,0,0,4.2,4.144l-1.708,4.236,8.134,3.279,1.743-4.323a18.145,18.145,0,0,0,5.788-.166l1.872,4.4,8.07-3.433-1.973-4.639a18.126,18.126,0,0,0,3.719-4.024Zm-12.429-7.027a9.071,9.071,0,0,1-1.3,1.493,9.111,9.111,0,0,1-4.93,2.36,9.043,9.043,0,0,1-1.627.093,9.024,9.024,0,0,1-3.086-.624,9.033,9.033,0,0,1-2.427-1.5,8.909,8.909,0,0,1-1.068-1.058,9.108,9.108,0,0,1-2.182-5.445,9.019,9.019,0,0,1,.078-1.678,9.067,9.067,0,0,1,.55-2.188,9.037,9.037,0,0,1,1.691-2.656,9.082,9.082,0,0,1,1.529-1.382,9.117,9.117,0,0,1,4.358-1.59,9,9,0,0,1,2.4.053,9.15,9.15,0,0,1,1.892.526,9.054,9.054,0,0,1,1.957,1.121,9.029,9.029,0,0,1,1.807,1.766A9.122,9.122,0,0,1-48.21-45a9.066,9.066,0,0,1,.117,2.351,9.04,9.04,0,0,1-.6,2.792,9.168,9.168,0,0,1-.934,1.727",
    transform: "translate(79.622 66.574)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M196.471-4.3H301.363V-9.212H196.471Z",
    transform: "translate(-91.784 267.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(29.776 66.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M-224.785-125.886H-481.169V-256.072a13.4,13.4,0,0,1,13.4-13.4H-238.18a13.4,13.4,0,0,1,13.4,13.4Z",
    transform: "translate(481.169 269.467)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665",
    transform: "translate(29.776 210.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M-213.089-21.546H-442.794a13.34,13.34,0,0,1-13.34-13.34V-46.12H-199.75v11.235a13.34,13.34,0,0,1-13.34,13.34",
    transform: "translate(456.134 46.12)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M309.533-353.552H72.068v126.4H309.533Z",
    transform: "translate(-33.668 428.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M299.846-76.263H252.427V-82.2h47.419Z",
    transform: "translate(-117.925 301.905)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667",
    transform: "translate(126.131 234.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M-55.827-20.7H-119.5l3.349-23.608h56.977Z",
    transform: "translate(119.501 44.307)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668",
    transform: "translate(129.111 234.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M-50.6-2.283h-57.714l.368-2.6h56.995Z",
    transform: "translate(108.315 4.886)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M447.841-156.533H410.584v-37.256h37.257Z",
    transform: "translate(-191.81 354.035)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M447.615-156.759H414.029v-33.587h33.586Z",
    transform: "translate(-193.419 352.427)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669",
    transform: "translate(220.609 172.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M-25.718-8.182a3.969,3.969,0,0,0-6.993-.005c-1.863,3.242-3.923,6.726-4.672,7.639h-.5C-39.234-2.566-43.5-17.737-47.89-17.511c-4.111.212-6.787,15-7.124,16.963h-.037V5.265h33.587V-.329Z",
    transform: "translate(55.051 17.514)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670",
    transform: "translate(241.59 167.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M-6.676-3.337A3.808,3.808,0,0,1-10.483.47,3.807,3.807,0,0,1-14.29-3.337a3.807,3.807,0,0,1,3.807-3.807A3.807,3.807,0,0,1-6.676-3.337",
    transform: "translate(14.29 7.144)",
    fill: "#f2a51c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M447.841-231.717H410.584v-37.256h37.257Z",
    transform: "translate(-191.81 389.159)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M447.615-231.943H414.029V-265.53h33.586Z",
    transform: "translate(-193.419 387.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672",
    transform: "translate(220.609 132.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M-25.718-8.182a3.969,3.969,0,0,0-6.993-.005c-1.863,3.242-3.923,6.727-4.672,7.64h-.5C-39.234-2.566-43.5-17.737-47.89-17.511c-4.111.212-6.787,15-7.124,16.964h-.037V5.265h33.587V-.329Z",
    transform: "translate(55.051 17.514)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673",
    transform: "translate(241.59 127.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M-6.676-3.338A3.807,3.807,0,0,1-10.483.469,3.807,3.807,0,0,1-14.29-3.338a3.807,3.807,0,0,1,3.807-3.807A3.807,3.807,0,0,1-6.676-3.338",
    transform: "translate(14.29 7.145)",
    fill: "#f2a51c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675",
    transform: "translate(254.975 116.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M-.463,0V.528H-.991V1.584H.593V0Z",
    transform: "translate(0.991)",
    fill: "#3a3ae2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M418.513-275.226h-2.067v1.056h2.067Zm4.135,0h-2.067v1.056h2.067Zm4.135,0h-2.067v1.056h2.067Zm4.134,0H428.85v1.056h2.067Zm4.135,0h-2.067v1.056h2.067Zm4.135,0H437.12v1.056h2.067Zm4.134,0h-2.068v1.056h2.068Zm4.135,0h-2.067v1.056h2.067Z",
    transform: "translate(-194.549 392.08)",
    fill: "#3a3ae2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676",
    transform: "translate(218.246 116.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M-1.389-.463h-.528V-.991H-2.973V.593h1.584Z",
    transform: "translate(2.973 0.991)",
    fill: "#3a3ae2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M410.649-338.294h-1.056v2.067h1.056Zm0,2.067,0,2.067h-1.056v2.067h1.056Zm0,2.067,0,2.067h-1.056v2.067h1.056Zm0,2.067,0,2.067h-1.056v2.067h1.056Zm0,2.067,0,2.067h-1.056v2.067h1.056Zm0,2.067,0,2.067h-1.056v2.067h1.056Zm0,2.067,0,2.068h-1.056v2.067h1.056Zm0,2.067,0,2.067h-1.056v2.067h1.056Z",
    transform: "translate(-191.347 421.543)",
    fill: "#3a3ae2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677",
    transform: "translate(218.246 79.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M-.926-1.389v-.528H-.4V-2.973H-1.982v1.584Z",
    transform: "translate(1.982 2.973)",
    fill: "#3a3ae2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M445.389-344.091h2.067v-1.056h-2.067Zm-4.135,0h2.068v-1.056h-2.068Zm-4.135,0h2.067v-1.056h-2.067Zm-4.134,0h2.067v-1.056h-2.067Zm-4.135,0h2.067v-1.056H428.85Zm-4.135,0h2.067v-1.056h-2.067Zm-4.134,0h2.067v-1.056h-2.067Zm-4.135,0h2.067v-1.056h-2.067Z",
    transform: "translate(-194.549 424.745)",
    fill: "#3a3ae2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678",
    transform: "translate(254.975 79.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M0-.926H.528V-.4H1.584V-1.982H0Z",
    transform: "translate(0 1.982)",
    fill: "#3a3ae2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M479.515-307.285h1.056v-2.067h-1.056Zm0-2.067,0-2.067h1.056v-2.068h-1.056Zm0-2.068,0-2.067h1.056v-2.067h-1.056Zm0-2.067,0-2.067h1.056v-2.067h-1.056Zm0-2.067,0-2.067h1.056v-2.067h-1.056Zm0-2.067,0-2.067h1.056v-2.068h-1.056Zm0-2.067,0-2.067h1.056v-2.067h-1.056Zm0-2.067,0-2.067h1.056V-338.3h-1.056Z",
    transform: "translate(-224.012 421.544)",
    fill: "#3a3ae2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M55.826-178.984h.03v-54.091h-.03Z",
    transform: "translate(-26.08 372.388)",
    fill: "#d3d1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M64.506-233.074H55.882v54.091h8.624Z",
    transform: "translate(-26.106 372.388)",
    fill: "#21118e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M104.657-233.074H72.067v54.091h32.59Z",
    transform: "translate(-33.667 372.388)",
    fill: "#d3d1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M69.664-183.587H1.407V-238.95H69.664Z",
    transform: "translate(-0.657 375.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M48.153-146.536H7.809V-150.7H48.153Z",
    transform: "translate(-3.648 333.905)",
    fill: "#9b2dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M107.195-146.536H89.047V-150.7h18.148Z",
    transform: "translate(-41.6 333.905)",
    fill: "#9b2dff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679",
    transform: "translate(16.95 143.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M-15.718-31.436A17.947,17.947,0,0,1-33.645-49.364,17.947,17.947,0,0,1-15.718-67.291,17.947,17.947,0,0,1,2.21-49.364,17.948,17.948,0,0,1-15.718-31.436m0-33.817a15.909,15.909,0,0,0-15.89,15.89,15.909,15.909,0,0,0,15.89,15.89A15.909,15.909,0,0,0,.173-49.364a15.909,15.909,0,0,0-15.89-15.89",
    transform: "translate(33.645 67.291)",
    fill: "#f2a51c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681",
    transform: "translate(29.746 154.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M-10.785-6.227l-12.3-7.1V.876Z",
    transform: "translate(23.087 13.329)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M262.891-375.075H115.434v3.18H262.891Z",
    transform: "translate(-53.927 438.726)",
    fill: "#d3d1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M262.891-369.107H115.434v8.288H262.891Z",
    transform: "translate(-53.927 435.938)",
    fill: "#21118e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M262.891-353.552H115.434v51.238H262.891Z",
    transform: "translate(-53.927 428.671)",
    fill: "#d3d1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M252.966-349.335H100.539v-99.339H252.966Z",
    transform: "translate(-46.968 473.109)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M251.913-350.252H116.588v-84.462H251.913Z",
    transform: "translate(-54.466 466.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M249-411.553h-125.9v-7.727H249Z",
    transform: "translate(-57.511 459.377)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M184.646-378.208h-61.54v-7.727h61.54Z",
    transform: "translate(-57.511 443.799)",
    fill: "#9b2dff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682",
    transform: "translate(65.067 57.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M-54.419-7.237v-.528h-61.012v-6.671h60.484v7.2h.528v0h.528v-8.255h-62.6V-6.71h62.6v-.528Z",
    transform: "translate(116.487 15.492)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M184.646-352.2h-61.54v-7.727h61.54Z",
    transform: "translate(-57.511 431.647)",
    fill: "#9b2dff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683",
    transform: "translate(65.067 71.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M-54.419-7.237v-.528h-61.012v-6.671h60.484v7.2h.528v0h.528v-8.255h-62.6V-6.71h62.6v-.528Z",
    transform: "translate(116.487 15.492)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M184.646-326.181h-61.54v-7.727h61.54Z",
    transform: "translate(-57.511 419.494)",
    fill: "#9b2dff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684",
    transform: "translate(65.067 85.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M-54.419-7.237v-.528h-61.012v-6.671h60.484v7.2h.528v0h.528v-8.255h-62.6V-6.71h62.6v-.528Z",
    transform: "translate(116.487 15.492)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M184.646-300.168h-61.54V-307.9h61.54Z",
    transform: "translate(-57.511 407.342)",
    fill: "#9b2dff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685",
    transform: "translate(65.067 98.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M-54.419-7.237v-.528h-61.012v-6.671h60.484v7.2h.528v0h.528v-8.255h-62.6v8.783h62.6v-.528Z",
    transform: "translate(116.487 15.492)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686",
    transform: "translate(140.031 61.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M-6.875,0A23.395,23.395,0,0,0-8.937,32.872L8.7,17.479Z",
    transform: "translate(14.717)",
    fill: "#9b2dff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687",
    transform: "translate(163.445 56.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M-20.168-16.366A23.43,23.43,0,0,0-38.919-35.033l-4.252,23.022Z",
    transform: "translate(43.171 35.033)",
    fill: "#e2e2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688",
    transform: "translate(147.873 56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M-17.381-.344a23.538,23.538,0,0,0-4.252-.392A23.323,23.323,0,0,0-37.205,5.2l15.572,17.479Z",
    transform: "translate(37.205 0.736)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689",
    transform: "translate(145.811 79.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M0-13.5A23.353,23.353,0,0,0,17.634-5.475a23.318,23.318,0,0,0,9.877-2.185L17.634-28.888Z",
    transform: "translate(0 28.888)",
    fill: "#ceceff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690",
    transform: "translate(163.445 75.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M0-3.818,9.877,17.411A23.413,23.413,0,0,0,23.414-3.818,23.5,23.5,0,0,0,23-8.173Z",
    transform: "translate(0 8.173)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691",
    transform: "translate(215.641 36.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M-91.545-21.979h-91.88A12.535,12.535,0,0,1-195.96-34.514a12.534,12.534,0,0,1,12.535-12.534h91.88A12.534,12.534,0,0,1-79.012-34.514,12.534,12.534,0,0,1-91.545-21.979",
    transform: "translate(195.96 47.048)",
    fill: "#9b2dff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692",
    transform: "translate(221.324 45.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M-89.759,0h-99.271a3.107,3.107,0,0,0-3.106,3.106h0a3.107,3.107,0,0,0,3.106,3.106h99.271a3.106,3.106,0,0,0,3.106-3.106h0A3.106,3.106,0,0,0-89.759,0",
    transform: "translate(192.137)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693",
    transform: "translate(227.456 40.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M-13.5-6.751a7.7,7.7,0,0,1-7.7,7.7,7.7,7.7,0,0,1-7.7-7.7,7.7,7.7,0,0,1,7.7-7.7,7.7,7.7,0,0,1,7.7,7.7",
    transform: "translate(28.902 14.451)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694",
    transform: "translate(81.518 134.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M-15.592,0A17.783,17.783,0,0,0-33.375,17.783,17.784,17.784,0,0,0-15.592,35.567,17.784,17.784,0,0,0,2.192,17.783,17.784,17.784,0,0,0-15.592,0m0,29.378A11.6,11.6,0,0,1-27.186,17.783a11.6,11.6,0,0,1,11.595-11.6A11.6,11.6,0,0,1-4,17.783a11.6,11.6,0,0,1-11.6,11.594",
    transform: "translate(33.375)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695",
    transform: "translate(87.707 140.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M-10.165-20.331A11.6,11.6,0,0,1-21.76-31.926,11.594,11.594,0,0,1-10.165-43.521,11.6,11.6,0,0,1,1.43-31.926a11.6,11.6,0,0,1-11.6,11.595",
    transform: "translate(21.76 43.521)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    transform: "translate(99.302 134.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M0,0V6.188a11.6,11.6,0,0,1,11.595,11.6,11.657,11.657,0,0,1-.227,2.281l4.9,4.9a17.715,17.715,0,0,0,1.515-7.182A17.783,17.783,0,0,0,0,0",
    transform: "translate(0)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697",
    transform: "translate(127.205 134.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M-15.592,0A17.783,17.783,0,0,0-33.375,17.783,17.784,17.784,0,0,0-15.592,35.567,17.783,17.783,0,0,0,2.192,17.783,17.783,17.783,0,0,0-15.592,0m0,29.378A11.6,11.6,0,0,1-27.186,17.783a11.6,11.6,0,0,1,11.595-11.6A11.6,11.6,0,0,1-4,17.783a11.6,11.6,0,0,1-11.6,11.594",
    transform: "translate(33.375)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698",
    transform: "translate(144.988 134.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M-6.863-8.126l3.768-4.945c-2.541-2.385-7.8-4.563-11.6-4.3v6.188A11.538,11.538,0,0,1-6.863-8.126",
    transform: "translate(14.69 17.394)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699",
    transform: "translate(133.393 140.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M-11.888-20.19a11.609,11.609,0,0,1-13.4-13.4,11.589,11.589,0,0,1,9.47-9.47,11.609,11.609,0,0,1,13.4,13.4,11.589,11.589,0,0,1-9.47,9.47",
    transform: "translate(25.447 43.219)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700",
    transform: "translate(178.563 139.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M-11.888-20.19a11.61,11.61,0,0,1-13.4-13.4,11.588,11.588,0,0,1,9.47-9.47,11.609,11.609,0,0,1,13.4,13.4,11.59,11.59,0,0,1-9.47,9.47",
    transform: "translate(25.447 43.219)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701",
    transform: "translate(172.374 133.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M-15.592,0A17.784,17.784,0,0,0-33.375,17.784,17.783,17.783,0,0,0-15.592,35.567,17.783,17.783,0,0,0,2.192,17.784,17.783,17.783,0,0,0-15.592,0m0,29.378A11.6,11.6,0,0,1-27.186,17.784a11.6,11.6,0,0,1,11.595-11.6A11.6,11.6,0,0,1-4,17.784a11.6,11.6,0,0,1-11.6,11.594",
    transform: "translate(33.375)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702",
    transform: "translate(190.157 133.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M-15.592-15.592A17.784,17.784,0,0,0-33.375-33.375v6.189A11.6,11.6,0,0,1-21.78-15.592a11.586,11.586,0,0,1-6.65,10.477l4.655,4.49a17.763,17.763,0,0,0,8.184-14.966",
    transform: "translate(33.375 33.375)",
    fill: "#9b2dff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M187.915-163.551h-36.3v-3.2h36.3Z",
    transform: "translate(-70.83 341.402)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M187.915-151.714h-36.3v-3.2h36.3Z",
    transform: "translate(-70.83 335.872)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M187.915-139.878h-36.3v-3.2h36.3Z",
    transform: "translate(-70.83 330.343)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M345.9-163.551H322.031v-3.2H345.9Z",
    transform: "translate(-150.441 341.402)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M358.329-151.714h-36.3v-3.2h36.3Z",
    transform: "translate(-150.441 335.872)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M336.794-139.878H322.031v-3.2h14.763Z",
    transform: "translate(-150.441 330.343)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M275.03-163.551h-36.3v-3.2h36.3Z",
    transform: "translate(-111.527 341.402)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M263.488-151.714H238.731v-3.2h24.757Z",
    transform: "translate(-111.527 335.872)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M275.03-139.878h-36.3v-3.2h36.3Z",
    transform: "translate(-111.527 330.343)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M581.137-326.034H548.53v-32.607h32.607Z",
    transform: "translate(-256.254 431.049)",
    fill: "#9b2dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M580.925-326.4H552.669V-354.66h28.256Z",
    transform: "translate(-258.187 429.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704",
    transform: "translate(297.856 78.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M-5.895-16.432h-.017a.82.82,0,0,1-.628-.315l-5.907-7.612A.815.815,0,0,1-12.3-25.5a.816.816,0,0,1,1.145.144l5.289,6.815L7.921-34.883a.816.816,0,0,1,1.15-.1.816.816,0,0,1,.1,1.15L-5.272-16.722a.815.815,0,0,1-.623.29",
    transform: "translate(12.619 35.173)",
    fill: "#9b2dff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.d35642f719a94edd2ecfd74fb9aaba6d.svg";
export { ForwardRef as ReactComponent };